import React, { useEffect, useRef } from "react";
import "./index.css";
import Home from "./routes/Home";
import Curriculum from "./routes/Curriculum";
import Bio from "./routes/Bio";
import Trailer from "./routes/Trailer";
import Form from "./routes/Form";
import Ritratti from "./routes/Ritratti";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Studi from "./routes/Studi.js";
import Cassandra from "./routes/Cassandra.js";
import Artemisia from "./routes/Artemisia.js";
import Ispirami from "./routes/Ispirami.js";
import Statement from "./routes/Statement.js";

function App() {
  const progressRef = useRef(null);
  const barRef = useRef(null);

  // Riporta in cima all'avvio (una sola volta).
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // TRASCINAMENTO col mouse -> scorrimento orizzontale della galleria.
  // Solo mouse: il dito su mobile usa lo scorrimento nativo.
  useEffect(() => {
    let scroller = null;
    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    let moved = false;

    const onPointerDown = (e) => {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      const el = e.target.closest && e.target.closest(".galleria, .hero");
      if (!el) return;
      scroller = el;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      dragging = true;
      moved = false;
      el.style.cursor = "grabbing";
      el.style.userSelect = "none";
    };

    const onPointerMove = (e) => {
      if (!dragging || !scroller) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      scroller.scrollLeft = startScroll - dx;
    };

    const endDrag = () => {
      if (scroller) {
        scroller.style.cursor = "";
        scroller.style.userSelect = "";
      }
      dragging = false;
      scroller = null;
    };

    const onClick = (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    };

    window.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", endDrag);
    window.addEventListener("pointercancel", endDrag);
    window.addEventListener("click", onClick, true);

    return () => {
      window.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", endDrag);
      window.removeEventListener("pointercancel", endDrag);
      window.removeEventListener("click", onClick, true);
    };
  }, []);

  // BARRA DI AVANZAMENTO: mostra a che punto sei nello scorrimento.
  // Si aggiorna mentre scorri/trascini e compare solo quando c'è
  // davvero una galleria scrollabile.
  useEffect(() => {
    const update = () => {
      const el = document.querySelector(".galleria, .hero");
      const wrap = progressRef.current;
      const bar = barRef.current;
      if (!wrap || !bar) return;
      if (!el) {
        wrap.style.opacity = "0";
        return;
      }
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 0) {
        wrap.style.opacity = "0";
        bar.style.width = "0%";
        return;
      }
      wrap.style.opacity = "1";
      bar.style.width = (el.scrollLeft / max) * 100 + "%";
    };

    document.addEventListener("scroll", update, true); // cattura lo scroll interno
    window.addEventListener("resize", update);

    // aggiorna quando cambia pagina (la galleria entra/esce dal DOM)
    let mo;
    const wrapperEl = document.querySelector(".wrapper");
    if (wrapperEl && "MutationObserver" in window) {
      mo = new MutationObserver(() => requestAnimationFrame(update));
      mo.observe(wrapperEl, { childList: true, subtree: true });
    }

    const raf = requestAnimationFrame(update);

    return () => {
      document.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
      if (mo) mo.disconnect();
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Trailer />} />
      </Routes>
      <div className="outer-wrapper">
        <div className="wrapper">
          <Navbar />

          <Routes>
            <Route path="Home" element={<Home />} />
            <Route path="Bio" element={<Bio />} />
            <Route path="Curriculum" element={<Curriculum />} />
            <Route path="Form" element={<Form />} />
            <Route path="Ritratti" element={<Ritratti />} />
            <Route path="Studi" element={<Studi />} />
            <Route path="Cassandra" element={<Cassandra />} />
            <Route path="Artemisia" element={<Artemisia />} />
            <Route path="Ispirami" element={<Ispirami />} />
            <Route path="Statement" element={<Statement />} />
          </Routes>
        </div>
      </div>

      {/* Barra di avanzamento dello scorrimento */}
      <div
        ref={progressRef}
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          height: "3px",
          background: "rgba(255, 255, 255, 0.08)",
          zIndex: 60,
          opacity: 0,
          transition: "opacity 0.35s ease",
          pointerEvents: "none"
        }}
      >
        <div
          ref={barRef}
          style={{
            height: "100%",
            width: "0%",
            background: "rgba(255, 255, 255, 0.55)",
            transition: "width 0.08s linear"
          }}
        />
      </div>
    </>
  );
}

export default App;
